import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../commonComponents/modal/Modal';
import translate from '../../../../commonComponents/translate';
import { TROPHY_CONFIG } from '../../../../services/utilityFunctions';
import TrophyModalItem from './TrophyModalItem';
import CloseIcon from '../../../../commonComponents/icons/icon/CloseIcon';

function TrophyModal({ t, trophies, onClose }) {
  const trophy = trophies.length > 0 ? TROPHY_CONFIG[trophies[0].type] : null;
  let name = trophy ? t(trophy.translationKey) : t('academyDetails_trophy');
  if (trophies[0]?.trophyCustom?.name) {
    name = trophies[0]?.trophyCustom?.name;
  }
  return (
    <Modal onClose={onClose} id="trophyModal">
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header-wrapper">
            <h5 className="title">{name}</h5>
            <button className="onClose-btn" type="button" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
          <div
            className="modal-body"
            style={{ maxHeight: '80vh', overflowY: 'auto' }}
          >
            <div className="m-timeline-3 trophy-timeline">
              <div className="m-timeline-3__items">
                {trophies?.length > 0 ? (
                  trophies.map(tr => (
                    <TrophyModalItem t={t} key={tr._id} trophy={tr} />
                  ))
                ) : (
                  <span className="no-data-hint">
                    {t('reports.journeys.table.trophy')}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

TrophyModal.propTypes = {
  t: PropTypes.func.isRequired,
  trophies: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default translate(TrophyModal);
